import { PAGE_IN_MODULE } from '@/utils/constUtils'
// import PageFaceIndex from '../pages/face/index.vue'
// import PageFaceForm from '../pages/face/form.vue'
// import PageFaceLayout from '../pages/entryInformation/components/layout.vue'
// import PageHomeSchool from '../pages/entryInformation/components/homeSchool.vue'
// import PageOrg from '../pages/entryInformation/components/org.vue'
// import PageFaceGuardian from '../pages/face/guardian/index.vue'
// import PageFaceGuardianList from '../pages/face/guardian/list.vue'

const modular = PAGE_IN_MODULE.face
export default [
  // {
  //   path: '/face/index',
  //   name: 'PageFaceIndex',
  //   component: PageFaceIndex,
  //   meta: { modular, title: '信息录入', info: '信息录入———首页' }
  // },
  // {
  //   path: '/face/homeSchool',
  //   name: 'PageFaceLayout',
  //   component: PageFaceLayout,
  //   // meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' },
  //   children: [
  //     {
  //       path: ':id',
  //       name: 'PageHomeSchool',
  //       component: PageHomeSchool,
  //       meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' }
  //     }
  //   ]
  // },
  // {
  //   path: '/face/org',
  //   name: 'PageFaceLayout',
  //   component: PageFaceLayout,
  //   // meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' },
  //   children: [
  //     {
  //       path: ':id',
  //       name: 'PageOrg',
  //       component: PageOrg,
  //       meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' }
  //     }
  //   ]
  // },
  // {
  //   path: '/face/form',
  //   name: 'PageFaceForm',
  //   component: PageFaceForm,
  //   meta: { modular, title: '身份信息管理', info: '身份信息管理———完善信息' }
  // },
  // {
  //   path: '/face/guardian',
  //   name: 'PageFaceGuardian',
  //   component: PageFaceGuardian,
  //   meta: { modular, title: '信息录入', info: '身份信息管理———完善信息' }
  // },
  // {
  //   path: '/face/guardian/list',
  //   name: 'PageFaceGuardianList',
  //   component: PageFaceGuardianList,
  //   meta: { modular, title: '身份信息管理', info: '身份信息管理———完善信息' }
  // }
  {
    path: '/face/faceInfo',
    name: 'PageFaceInfo',
    component: () => import('../pages/face/faceInfo.vue'),
    meta: {
      modular,
      title: '录入人脸',
      info: '录入人脸-信息'
    }
  }
]
